'use strict';
const rest = {};

// QUERY
rest.Query = function(service, resource) {
    this.service = service;
    this.resource = resource;
    this.params = {};
};

/**
 * Specify WHERE-condition in Yii-style, for example:
 * ["and", ["<=", "id", 5], [">", "id", "1"]]
 * @param {Array|Object} where
 */
rest.Query.prototype.where = function(where) {
    this.params.where = where;
};

rest.Query.prototype.when = function(when) {
    this.params.when = when;
};

rest.Query.prototype.available_date = function(available_date) {
    this.params.available_date = available_date;
};

rest.Query.prototype.services = function(services) {
    this.params.services = services;
};
rest.Query.prototype.filters = function(filters) {
    this.params.filters = filters;
};
rest.Query.prototype.from = function(from) {
    this.params.from = from;
};

rest.Query.prototype.order = function(field, isAsc) {
    if (isAsc !== false && isAsc !== true) {
        isAsc = true;
    }

    this.params.sort = (isAsc === true ? '' : '-') + field;
};

rest.Query.prototype.pageSize = function(pageSize) {
    if (!this.params.hasOwnProperty('pagination')) {
        this.params.pagination = {};
    }

    this.params.pagination.pageSize = pageSize;
};

rest.Query.prototype.page = function(page) {
    this.params.page = page;
};

rest.Query.prototype.expand = function(entity) {
    if (this.params.hasOwnProperty('expand')) {
        this.params.expand += ',' + entity;
    } else {
        this.params.expand = entity;
    }
};

rest.Query.prototype.field = function(field) {
    if (this.params.hasOwnProperty('fields')) {
        this.params.fields += ',' + field;
    } else {
        this.params.fields = field;
    }
};

rest.Query.prototype.fields = function(fields) {
    fields.forEach(function(elem) {
        this.field(elem);
    }.bind(this));
};

/**
 * @param {Function} callback
 */
rest.Query.prototype.evaluate = function(callback) {
    this.service.read(this.resource, this.params, callback);
};

// RESPONSE
/**
 * @param {XMLHttpRequest} xhr
 * @constructor
 */
rest.Response = function Response(xhr) {
    this._xhr = xhr;
    this._links = {};
    this._pagination = {};

    this._parseResponse();
    this._parseLinks();
    this._parsePagination();
};

rest.Response.prototype._parseResponse = function() {
    if (this._xhr.getResponseHeader('Content-Type').indexOf('application/json') < 0) {
        throw new Error('Invalid Content-Type');
    }

    this.data = JSON.parse(this._xhr.responseText);
};

rest.Response.prototype._parseLinks = function() {
    let links = this._xhr.getResponseHeader('Link');

    if (links) {
        links = links.split(', ');
        for (const linkIndex in links) {
            const link = links[linkIndex];
            const linkParts = link.split('; rel=');
            const linkValue = linkParts[0].substr(1, linkParts[0].length - 2);
            const linkName = linkParts[1];
            this._links[linkName] = linkValue;
        }
    }
};

rest.Response.prototype._parsePagination = function() {
    this._pagination['currentPage'] = parseInt(this._xhr.getResponseHeader('X-Pagination-Current-Page'));
    this._pagination['totalCount'] = parseInt(this._xhr.getResponseHeader('X-Pagination-Total-Count'));
    this._pagination['pageCount'] = parseInt(this._xhr.getResponseHeader('X-Pagination-Page-Count'));
    this._pagination['perPage'] = parseInt(this._xhr.getResponseHeader('X-Pagination-Per-Page'));
};

rest.Response.prototype._link = function(linkName) {
    return this._links.hasOwnProperty(linkName) ? this._links[linkName] : null;
};

rest.Response.prototype.nextLink = function() {
    return this._link('next');
};

rest.Response.prototype.prevLink = function() {
    return this._link('prev');
};

rest.Response.prototype.firstLink = function() {
    return this._link('first');
};

rest.Response.prototype.lastLink = function() {
    return this._link('last');
};

rest.Response.prototype.selfLink = function() {
    return this._link('self');
};

rest.Response.prototype.currentPage = function() {
    return this._pagination['currentPage'];
};

rest.Response.prototype.totalCount = function() {
    return this._pagination['totalCount'];
};

rest.Response.prototype.pageCount = function() {
    return this._pagination['pageCount'];
};

rest.Response.prototype.perPage = function() {
    return this._pagination['perPage'];
};

rest.Response.prototype.firstIndex = function() {
    return Math.min(1 + this.perPage() * (this.currentPage() - 1), this.totalCount());
};

rest.Response.prototype.lastIndex = function() {
    return Math.min(this.perPage() * this.currentPage(), this.totalCount());
};

// RESTSERVICE
rest.RestService = function(url) {
    this.url = url;
};

rest.RestService.STATUS_VALIDATION_FAILED = 422;

rest.RestService.prototype._serializeParams = function(params, _prefix) {
    const str = [];
    for (const param in params) {
        const k = _prefix ? _prefix + '[' + param + ']' : param; const v = params[param];
        str.push(typeof v == 'object' ?
            this._serializeParams(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v));
    }
    return str.join('&');
};

rest.RestService.prototype._sendRequest = function(method, url, params, callback) {
    if (['GET', 'POST', 'PUT', 'DELETE'].indexOf(method) === -1) {
        throw new Error('Invalid method: ' + method);
    }

    const serializedParams = this._serializeParams(params);
    const targetUri = this.url + url + (method === 'GET' && serializedParams.length > 0 ? '?' + serializedParams : '');
    const body = method !== 'GET' ? serializedParams : null;

    const xhr = new XMLHttpRequest();
    xhr.open(method, targetUri);

    if (method !== 'GET') {
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }

    xhr.setRequestHeader('Accept', 'application/json');
    xhr.getResponseHeader('Content-Type');
    xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            // console.log(decodeURIComponent(xhr.responseURL));
            const response = new rest.Response(xhr);

            if (callback) {
                callback(response);
            }
        }
    };
    xhr.send(body);
};

rest.RestService.prototype.read = function(url, params, callback) {
    return this._sendRequest('GET', url, params, callback);
};

rest.RestService.prototype.create = function(url, params, callback) {
    return this._sendRequest('POST', url, params, callback);
};

rest.RestService.prototype.update = function(url, params, callback) {
    return this._sendRequest('PUT', url, params, callback);
};

rest.RestService.prototype.delete = function(url, params, callback) {
    return this._sendRequest('DELETE', url, params, callback);
};

// TICKETSERVICE
/**
 * @param {rest.RestService} restService
 * @type {Function}
 */

rest.TicketService = (function(restService) {
    return {
        getServices: function(shopId, callback) {
            restService.read('/shops/' + shopId, {expand: 'default_service_costs'}, function(response) {
                if (response._xhr.status !== 200) {
                    throw new Error;
                }

                if (callback) {
                    callback(response.data.default_service_costs);
                }
            });
        },

        getTimes: function(shopId, date, services, callback) {
            restService.read('/available-times', {
                shop: shopId,
                day: date,
                services: services,
                filters: 'uniqtime',
            }, function(response) {
                if (response._xhr.status !== 200) {
                    throw new Error;
                }

                if (callback) {
                    callback(response.data);
                }
            });
        },

        createTicket: function(params, callback) {
            restService.create('/tickets', params, function(response) {
                if (response._xhr.status !== 201) {
                    throw new Error;
                }

                if (callback) {
                    callback(response.data);
                }
            });
        },

        createReview: function(params, callback) {
            restService.create('/reviews', params, function(response) {
                if (response._xhr.status !== 201) {
                    throw new Error;
                }

                if (callback) {
                    callback(response.data);
                }
            });
        },
    };
});

export default rest;
